import { Component, OnInit } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as State from '@shared/state';
import { Observable } from 'rxjs';

@Component({
    selector: 'shared-auth-account-balance',
    templateUrl: './auth-account-balance.shared.component.html',
    styleUrls: ['./auth-account-balance.shared.component.scss']
})
export class AuthAccountBalanceComponent implements OnInit {
    public accountBalance$: Observable<State.IAccountBalance>;
    public hideAmount$: Observable<boolean>;
    constructor(
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.accountBalance$ = this.controllers.members.getAccountBalance$();
        this.hideAmount$ = this.controllers.members.hideAccountBalanceAmount$();
    }
}
